<div class="container">
  <div class="offset-1 col-10">
     <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-sm-6 text-left">
                    <h5 class=" card-category">Risk Management</h5>
                    <h2 class=" card-title"><i class="fab fa-buffer fa-lg"></i>&nbsp;&nbsp;&nbsp; Constant Proportion Portfolio Insurance</h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">

                <div class="row mt-3">
                  <div class="offset-1 col-10">
                    <p>Thanks to a CPPI strategy, you may maintain exposure to the upside potential of the risky asset (Investable Portfolio) while providing a capital guarantee against downside risk. The outcome is somewhat similar to that of buying a call option, but does not use option contracts.</p>
                  </div>
                  <div class="col-6 mt-3" style="line-height: 30px">
                    <div class="w-100" style="border-top:1px dotted grey"></div>
                    <div>
                      <span style="color: grey">Initial Capital</span>
                      <span class="float-right">
                          {{ parameters.initial_capital | number:'1.1-1' }}
                      </span>
                      <br>
                    </div>
                  </div>
                  <div class="col-6 mt-3" style="line-height: 30px">
                    <div class="w-100" style="border-top:1px dotted grey"></div>
                    <div>
                      <span style="color: grey">Aggressiveness</span>
                      <span class="float-right">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                          <mat-select [(value)]="parameters.aggressiveness" (selectionChange)="onParameterChange()" [disabled]="isComputing">
                            <mat-option value="defensive">Defensive</mat-option>
                            <mat-option value="moderate">Moderate</mat-option>
                            <mat-option value="aggressive">Aggressive</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                    </div>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span style="color: grey">Risk Free Rate</span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;width:50px;">
                        <input matInput type="number" [(ngModel)]="parameters.risk_free_rate" (change)="onParameterChange()" [step]="0.1" [disabled]="isComputing">
                      </mat-form-field>
                      %
                    </span>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span style="color: grey">Protection Horizon</span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                        <mat-select [(value)]="parameters.protection_horizon" (selectionChange)="onParameterChange()" [disabled]="isComputing">
                          <mat-option value="three_years">3 Years</mat-option>
                          <mat-option value="one_year">1 Year</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span class="float-left">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                        <mat-select [(value)]="parameters.target_type" (selectionChange)="onParameterChange()" [disabled]="isComputing">
                          <mat-option value="maximum_loss">Max Loss</mat-option>
                          <mat-option value="maximum_drawdown">Max Drawdown</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;width:50px;">
                        <mat-select [(value)]="parameters.protection_level" (selectionChange)="onParameterChange()" [disabled]="isComputing">
                          <mat-option [value]="10">10</mat-option>
                          <mat-option [value]="20">20</mat-option>
                          <mat-option [value]="30">30</mat-option>
                        </mat-select>
                      </mat-form-field>
                      %
                    </span>
                    <br>
                    <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span style="color: grey">Rebalancing Frequency</span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                        <mat-select [(value)]="parameters.rebalancing_frequency" (selectionChange)="onParameterChange()" [disabled]="isComputing">
                          <mat-option value="monthly">Monthly</mat-option>
                          <mat-option value="weekly">Weekly</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                  </div>
                </div>

              </div>
              <div class=" card-footer">
                <div class="col-12 text-center">
                  <app-button [disabled]="isComputing" (click)="onCompute()">Compute</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  <div class=" content" *ngIf="showResults">
    <br>
    <div class=" row">
      <div class=" col-12">
        <div class=" card card-chart">
          <div class=" card-header">
            <div class=" row">
              <div class=" col-sm-6 text-left">
                <h2 class=" card-title">Backtest</h2>
              </div>
              <div class=" col-sm-6">
                <div class=" btn-group float-right">
                  <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='cppi'}"
                         (click)="selectedPage='cppi'">Accrued</label>
                  <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='synthesis'}"
                         (click)="selectedPage='synthesis';selectedTab='Max Loss'">Analytics</label>
                </div>
              </div>
            </div>
          </div>
          <div class=" card-body">
            <div *ngIf="selectedPage=='cppi'">
              <!-- CPPI line chart -->
              <app-basic-line-chart *ngIf="insuranceMetrics"
                                    [series]="[
                                      {label: 'investable', historical_values: investableMA.historical_values},
                                      {label: 'protected',  historical_values: insuranceMetrics.historical_values},
                                      {label: 'floor',      historical_values: insuranceMetrics.floor_historical_values},
                                      {label: 'risky_part', historical_values: insuranceMetrics.risky_part_historical_values},
                                      {label: 'cushion',    historical_values: insuranceMetrics.cushion_historical_values}
                                    ]" height="400px">
              </app-basic-line-chart>
              <!-- CPPI line chart -->
            </div>
            <div *ngIf="selectedPage=='synthesis'">
              <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
                <!--    .                                      -->
                <!--   / \   Do not change mat-tab labels.     -->
                <!--  / ! \  They are used in typescript code. -->
                <!-- /_____\                                   -->
                <mat-tab *ngIf="insuranceMetrics[parameters.protection_horizon].maximum_loss" label="Max Loss"></mat-tab>
                <mat-tab *ngIf="insuranceMetrics[parameters.protection_horizon].maximum_drawdown" label="Max Drawdown"></mat-tab>
                <mat-tab *ngIf="insuranceMetrics[parameters.protection_horizon].returns" label="Returns"></mat-tab>
                <mat-tab *ngIf="insuranceMetrics[parameters.protection_horizon].volatility" label="Volatility"></mat-tab>
              </mat-tab-group>

              <br>
              <div *ngFor="let pivot of ['yearly','one_year','three_years']">
                <!-- Max Loss bar chart -->
                <app-basic-bar-chart *ngIf="selectedTab == 'Max Loss' &&
                                        pivot == parameters.protection_horizon &&
                                        investableMA[parameters.protection_horizon]"
                                     [series]="[
                                    {label: 'investable', values: getFormattedPeriodValues('investable','maximum_loss',false,pivot)},
                                    {label: 'protected',  values: getFormattedPeriodValues('protected','maximum_loss',false,pivot)}
                                  ]" opposite percent>
                </app-basic-bar-chart>
                <!-- Max Loss bar chart -->
                <!-- Max Drawdown bar chart -->
                <app-basic-bar-chart *ngIf="selectedTab == 'Max Drawdown' &&
                                      pivot == parameters.protection_horizon &&
                                      investableMA[parameters.protection_horizon]"
                                     [series]="[
                                  {label: 'investable', values: getFormattedPeriodValues('investable','maximum_drawdown',false,pivot)},
                                  {label: 'protected',  values: getFormattedPeriodValues('protected','maximum_drawdown',false,pivot)}
                                ]" opposite percent>
                </app-basic-bar-chart>
                <!-- Max Drawdown bar chart -->
                <!-- Returns bar chart -->
                <app-basic-bar-chart *ngIf="selectedTab == 'Returns' &&
                                      pivot == parameters.protection_horizon &&
                                      investableMA[parameters.protection_horizon]"
                                     [series]="[
                                  {label: 'investable', values: getFormattedPeriodValues('investable','returns',false,pivot)},
                                  {label: 'protected',  values: getFormattedPeriodValues('protected','returns',false,pivot)}
                                ]" percent>
                </app-basic-bar-chart>
                <!-- Returns bar chart -->
                <!-- Volatility bar chart -->
                <app-basic-bar-chart *ngIf="selectedTab == 'Volatility' &&
                                      pivot == parameters.protection_horizon &&
                                      investableMA[parameters.protection_horizon]"
                                     [series]="[
                                  {label: 'investable', values: getFormattedPeriodValues('investable','volatility',false,pivot)},
                                  {label: 'protected',  values: getFormattedPeriodValues('protected','volatility',false,pivot)}
                                ]" percent>
                </app-basic-bar-chart>
                <!-- Volatility bar chart -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="selectedPage=='synthesis'" class=" content">
      <br>
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-12 text-center">
                  <h2 class=" card-title">{{ selectedTab }}</h2>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <!-- Max Loss table -->
              <table *ngIf="selectedTab=='Max Loss'" mdbTable small="true">
                <thead>
                <tr>
                  <th scope="col" width="30%"></th>
                  <th *ngFor="let period of getFormattedPeriods()">
                    {{ period }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th class="casino" scope="row">Investable</th>
                  <td *ngFor="let maximum_loss of getPeriodValues('investable','maximum_loss')">
                    {{ maximum_loss | percent:'.1' }}
                  </td>
                </tr>
                <tr>
                  <th class="casino" scope="row">Protected</th>
                  <td *ngFor="let maximum_loss of getPeriodValues('protected','maximum_loss')">
                    {{ maximum_loss | percent:'.1' }}
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- Max Loss table -->

              <!-- Max Drawdown table -->
              <table *ngIf="selectedTab=='Max Drawdown'" mdbTable small="true">
                <thead>
                <tr>
                  <th scope="col" width="30%"></th>
                  <th *ngFor="let period of getFormattedPeriods()">
                    {{ period }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th class="casino" scope="row">Investable</th>
                  <td *ngFor="let maximum_drawdown of getPeriodValues('investable','maximum_drawdown')">
                    {{ maximum_drawdown | percent:'.1' }}
                  </td>
                </tr>
                <tr>
                  <th class="casino" scope="row">Protected</th>
                  <td *ngFor="let maximum_drawdown of getPeriodValues('protected','maximum_drawdown')">
                    {{ maximum_drawdown | percent:'.1' }}
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- Max Drawdown table -->

              <!-- Returns table -->
              <table *ngIf="selectedTab=='Returns'" mdbTable small="true">
                <thead>
                <tr>
                  <th scope="col" width="30%"></th>
                  <th *ngFor="let period of getFormattedPeriods()">
                    {{ period }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th class="casino" scope="row">Investable</th>
                  <td *ngFor="let returns of getPeriodValues('investable','returns')">
                    {{ returns | percent:'.1' }}
                  </td>
                </tr>
                <tr>
                  <th class="casino" scope="row">Protected</th>
                  <td *ngFor="let returns of getPeriodValues('protected','returns')">
                    {{ returns | percent:'.1' }}
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- Returns table -->

              <!-- Volatility table -->
              <table *ngIf="selectedTab=='Volatility'" mdbTable small="true">
                <thead>
                <tr>
                  <th scope="col" width="30%"></th>
                  <th *ngFor="let period of getFormattedPeriods()">
                    {{ period }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th class="casino" scope="row">Investable</th>
                  <td *ngFor="let volatility of getPeriodValues('investable','volatility')">
                    {{ volatility | percent:'.1' }}
                  </td>
                </tr>
                <tr>
                  <th class="casino" scope="row">Protected</th>
                  <td *ngFor="let volatility of getPeriodValues('protected','volatility')">
                    {{ volatility | percent:'.1' }}
                  </td>
                </tr>
                </tbody>
              </table>
              <!-- Volatility table -->

              <div class="w-100">
                <em class="float-right" style="font-size:0.7em">
                  {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                </em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <br>
</div>
</div>
